import {useEffect, useRef} from 'react';
import {isObject} from '../lib/utils';

export function usePrevious<T>(value: T, defaultValue?: T) {
  const ref = useRef<T | undefined>(defaultValue);

  useEffect(() => {
    ref.current = isObject(value) ? {...value} : value;
  }, [value]);

  return ref.current;
}
